import { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { useTranslation } from "react-i18next";
import { useLocation, useParams, useNavigate, NavLink } from "react-router-dom";
import { Logo } from "../../static/icons/Logo";
import { Box, FormControl, MenuItem, Select } from "@mui/material";
import { LocalizationService } from "../../locales/i18n";
import { generateNavigatinPath, getBasePath } from "../../utils/navigation";
import { find } from "lodash";
import { routes } from "../../static/routes";

import { useSelector } from "react-redux";

export const Navigation = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const { user_type, version, lang } = useParams();
  const [language, setLanguage] = useState(lang);
  const languages = useSelector((state) => state.uiReducer.languages);

  const basePath = getBasePath(params, location.pathname);

  const toRoute = find(routes, function (route) {
    return route.path.includes(basePath);
  }).path;

  const handleChangeLang = async (event) => {
    const lang = event.target.value;
    setLanguage(lang);
    const path = generateNavigatinPath({
      url: toRoute,
      user_type,
      version,
      lang,
    });
    await LocalizationService.changeLanguage(lang);
    navigate(path);
  };

  return (
    <AppBar position="fixed">
      <Toolbar>
        <Logo />
        <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "row", mx: 2 }}>
          {routes.map((page) => {
            const path = generateNavigatinPath({
              url: page.path,
              user_type,
              version,
              lang: language,
            });

            return (
              <NavLink
                to={path}
                key={page.title}
                style={({ isActive }) => {
                  return {
                    textDecoration: "none",
                    marginRight: "10px",
                    color: isActive
                      ? "rgba(37, 38, 38, 1)"
                      : "rgba(14, 38, 35, 0.5)",
                  };
                }}
              >
                {t(page.title)}
              </NavLink>
            );
          })}
        </Box>
        <Box
          sx={{
            flexGrow: 0,
          }}
        >
          {user_type !== "clinical_team" && (
            <FormControl sx={{ m: 1, minWidth: 120 }}>
              <Select
                value={language}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                onChange={handleChangeLang}
              >
                {languages.map((lang) => (
                  <MenuItem value={lang.code} key={`lang-${lang.code}`}>
                    {lang.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};
